import axios from 'axios';

export default {
  setup() {
    axios.interceptors.response.use(
      response => {
        return response;
      },
      function(error) {
        let originalRequest = error.config;

        if (
          error.response &&
          error.response.status === 401 &&
          !originalRequest._retry &&
          !window.location.href.endsWith('signin')
        ) {
          window.location.href = '/account/signin';
          return;
        }

        return Promise.reject(error);
      }
    );
  },
};



// WEBPACK FOOTER //
// ./src/setupInterceptors.js